import { SortResult } from '@/components';
import { Http, Paged, Paging } from '@/core';
import { guard } from '@/utils';
import qs from 'qs';
import {
  AddAnnouncementDto,
  AnnouncementDto,
  AnnouncementLookupDto,
  UpdateAnnouncementDto,
} from './announcementTypes';

class AnnouncementsHttp extends Http {
  public async getAll(statuses?: string[]) {
    let url = '/api/announcement';
    if (statuses && statuses.length > 0) {
      const query = qs.stringify({ statuses });
      url = `${url}?${query}`;
    }
    const response = await this._axios.get<AnnouncementDto[]>(url);
    return response.data;
  }

  public async getPending() {
    const response = await this._axios.get<AnnouncementDto[]>(
      `/api/announcement/pending`,
    );
    return response.data;
  }

  public async search(args: {
    searchString?: string;
    paging: Paging;
    sorting?: SortResult;
  }) {
    const query = qs.stringify(args);
    const response = await this._axios.get<Paged<AnnouncementLookupDto>>(
      `/api/announcement/search?${query}`,
    );
    return response.data;
  }

  public async get(id: string) {
    guard.notNull(id, 'id');
    const response = await this._axios.get<AnnouncementDto>(
      `/api/announcement/${id}`,
    );
    return response.data;
  }

  public async create(request: AddAnnouncementDto) {
    guard.notNull(request, 'request');
    const response = await this._axios.post<string>(
      '/api/announcement',
      request,
    );
    return response.data;
  }

  public async update(request: UpdateAnnouncementDto) {
    guard.notNull(request, 'request');
    await this._axios.put('/api/announcement', request);
  }

  public async remove(id: string) {
    guard.notNull(id, 'id');
    await this._axios.delete(`/api/announcement/${id}`);
  }

  public async accept(id: string) {
    guard.notNull(id, 'id');
    await this._axios.put(`/api/announcement/${id}/accept`);
  }

  public async publish(id: string) {
    guard.notNull(id, 'id');
    await this._axios.put(`/api/announcement/${id}/publish`);
  }
}

export const announcementsHttp = new AnnouncementsHttp();
